/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class InventoryResourceDetailsDataModel {
    getFixupPrototypeFunction() { return InventoryResourceDetailsDataModel.fixupPrototype; }

    static newInstance(model: Partial<InventoryResourceDetailsDataModel>): InventoryResourceDetailsDataModel {
        let obj = Object.assign(new InventoryResourceDetailsDataModel(), model);
        InventoryResourceDetailsDataModel.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<InventoryResourceDetailsDataModel>): InventoryResourceDetailsDataModel {
        if (!model) return null;
        return InventoryResourceDetailsDataModel.newInstance(<InventoryResourceDetailsDataModel> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: InventoryResourceDetailsDataModel) {
        if (!obj) return;

        models.InventoryResourceDetailsDataModel.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: InventoryResourceDetailsDataModel): boolean {
        Object.setPrototypeOf(obj, InventoryResourceDetailsDataModel.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.cloud_account) {
            for (let val of this.cloud_account) {
                models.CloudAccountDetail.fixupPrototype(val);
            }
        }
    }

    /**
     * Id of the cloud account
     */
    cloud_account: Array<models.CloudAccountDetail>;

    /**
     * Cloud service name
     */
    service: models.CloudServiceName;

    /**
     * Name of the resource category. It can be fetched from the Get Inventory Count Api
     */
    category: string;

    /**
     * Name of the resource type. It can be fetched from the Get Inventory Count Api
     */
    component: string;

    /**
     * Name of the resource. It can be fetched from the Get Inventory Count Api
     */
    resource: string;

    /**
     * Specify the Operation ID. It can be fetched from the Get Inventory Count Api
     */
    operation_id: string;

    /**
     * Specify to fetch the live ping status of the AWS SSM enabled instance.
     */
    fetch_live_status: boolean;

}
